module.exports = __webpack_public_path__ + "media/images/wakatta-icon_off-e6176c670a2867d492ccbf735c369bbc.png";